import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";
import { Redirect } from "react-router-dom";

import { handleModalState } from "common-components/Modal/actions/handleModalState";
import { requestDownload } from "../actions";
import { setA11yContent } from "../../NavigationHelper/actions";
import { replaceHashValues } from "utils/replaceHashValues";
import { formatPhoneNumber } from "utils/formatPhoneNumber";
import { checkNestedObject } from "utils/checkNestedObject";
import { checkAMLob } from "utils/checkAMLob";

// import Button from "common-components/Buttons";
import { ButtonGroup } from "@vds/buttons";
import { TitleLockup } from "@vds/type-lockups";
import { VDSManager } from "@vds/utilities";
import CommonContainer from "common-components/Container";
import CommonHeader from "common-components/Header";
import DownloadSuccess from "../SuccessModals/DownloadSuccess/DownloadSuccess";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import Alert from "common-components/Alert";
import { media, isMobile } from "utils/style";

class ReviewDownload extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("Download review", this.props.pageContent.sc_pagetitle);
    }
  }

  requestDownload = () => {
    this.props.requestDownload().then(() => {
      if (!this.props.error) {
        this.props.handleModalState();
      }
    });
  };

  checkNotificationMethod = (mdn, email) => {
    let notificationMethod = "";

    if (mdn && email) {
      notificationMethod = `${email}, and ${formatPhoneNumber(mdn)}`;
    } else if (mdn) {
      notificationMethod = formatPhoneNumber(mdn);
    } else {
      notificationMethod = email;
    }
    return notificationMethod;
  };

  renderNotificationMethod = () => {
    const { loggedInMdn, wlnMdn, accountEmail, accountOttEmail, accountCvaEmail } = window.reactGlobals;

    if (checkAMLob() === "ott") {
      return this.checkNotificationMethod(loggedInMdn, accountOttEmail);
    } else if (checkAMLob() === "vzt") {
      return this.checkNotificationMethod(wlnMdn, accountEmail);
    } else if (checkAMLob() === "autoapp") {
      return this.checkNotificationMethod(loggedInMdn, accountCvaEmail);
    }
    return this.checkNotificationMethod(loggedInMdn, accountEmail);
  };

  render() {
    const { pageContent, loading } = this.props;
    const { wlnAccountNumber } = window.reactGlobals;

    if (!pageContent) {
      return <Redirect to="/privacy/secure/your-data" />;
    }

    if (loading) {
      return <RectangleLoader />;
    }

    return (
      <div>
        <Container>
          <TitleLockup
            surface='light'
            textAlignment='left'
            viewport={isMobile ? "mobile" : "desktop"}
            data={{
              title: {
                size: 'titleXLarge',
                bold: false,
                children: convertStringToElements(pageContent.section_title)
              },
              subtitle: {
                size: 'bodyLarge',
                children: <Div>
                  <p data-qm-encrypt="true" >
                  {convertStringToElements(
                    replaceHashValues(pageContent.Category[0].category_description, {
                      dateRangeSelected: this.props.downloadAmount.label,
                      deviceName: this.props.deviceName,
                      mdn: this.props.mdn || wlnAccountNumber
                    })
                  )}
                  </p>
                  <ul>
                    {this.props.downloadCategories.map(item =>
                      item.checked ? <li key={item.category_id}>{item.category_name}</li> : null
                    )}
                  </ul>

                  {convertStringToElements(
                    replaceHashValues(pageContent.Category[0].category_sub_description, {
                      notificationMethod: this.renderNotificationMethod(),
                      accountNumber: wlnAccountNumber
                    })
                  )}

                </Div>
              }

            }}
          />
          <VDSManager>
            <ButtonGroup
              childWidth={'100%'}
              // viewPort=""
              rowQuantity={{ desktop: 2, mobile: 1 }}
              data={[
                {
                  children:<span data-qm-encrypt="true" style={{fontFamily:'Verizon-NHG-eDS, Helvetica, Arial, sans-serif'}}>{pageContent.buttons[0].text} </span>,
                  size: 'large',
                  use: pageContent.buttons[0].type !== "white_background" ? 'primary' : 'secondary',
                  width: isMobile ? '100%' : '226px',
                  onClick: () => this.requestDownload(),
                },
                {
                  children: <span style={{fontFamily:'Verizon-NHG-eDS, Helvetica, Arial, sans-serif'}}>{pageContent.buttons[1].text}</span>,
                  size: 'large',
                  use: pageContent.buttons[1].type !== "white_background" ? 'primary' : 'secondary',
                  width: isMobile ? '100%' : '226px',
                  onClick: () => this.props.history.push("/privacy/secure/your-data"),
                },
              ]}
              alignment={isMobile ? 'center' : ''}
            />
          </VDSManager>

          {this.props.error ? <Alert alertType="error">{this.props.error}</Alert> : null}
        </Container>
        {this.props.showModal ? (
          <DownloadSuccess
            modalContent={this.props.modalContent}
            handleClick={() => this.props.history.push("/privacy/secure/your-data")}
          />
        ) : null}
      </div>

    );
  }
}

const mapStateToProps = ({
  modalState,
  loadingAndErrorState,
  downloadInputInformation,
  pageContent,
  downloadAmount,
  selectedDevice
}) => ({
  showModal: modalState.showModal,
  loading: loadingAndErrorState.loading,
  error: loadingAndErrorState.error,
  downloadCategories: downloadInputInformation.downloadCategories,
  pageContent: pageContent.download_review,
  modalContent: pageContent.download_success_modal,
  deviceName: selectedDevice.displayName,
  mdn: formatPhoneNumber(selectedDevice.mtn),
  downloadAmount
});

export default connect(
  mapStateToProps,
  { handleModalState, requestDownload, setA11yContent }
)(ReviewDownload);

const Div = styled.div`
  max-width: 595px;

  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.5px;
    margin-bottom:50px;

  p {
    padding: 10px 0;
  }

  ul {
    margin: 10px 0px 10px 0px;
  }

`;


const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
    margin: 0;
    padding: 32px 16px ;
  `}
`;


const Header = styled(CommonHeader)`
  max-width: 598px;
  font-size: 48px;
  line-height: 48px;
  margin-bottom: 12px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-weight: 300;

${media.mobile`
  font-size: 32px;	
  line-height: 36px;
  font-weight: 300;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
`}
`;
